import { yup } from 'straightline-utils/validation';

export default (app) => {
  return yup.object({
    text: yup.string().trim().required().label('Text')
  });
};
